"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisembowelAbilityHandler = exports.DisembowelActorAbilityFactory = exports.DisembowelAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DisembowelAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Disembowel;
        this.__typeName = "Disembowel";
    }
}
exports.DisembowelAbilityArgs = DisembowelAbilityArgs;
let DisembowelActorAbilityFactory = class DisembowelActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Disembowel", "OneEnemies", 3);
    }
};
DisembowelActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Disembowel")
], DisembowelActorAbilityFactory);
exports.DisembowelActorAbilityFactory = DisembowelActorAbilityFactory;
let DisembowelAbilityHandler = class DisembowelAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const vulnerabilityStacks = container.getAttributeScore(selectedEnemy, enums_1.AttributeType.VulnerabilityStacks);
        let multiplier = 1;
        if (vulnerabilityStacks > 0) {
            multiplier += .3;
        }
        if (container.hasAttribute(ability.invokerId, "Charm_Gladiator_1")
            && container.getCurrentHealthPercent(ability.invokerId) <= container.getCurrentHealthPercent(selectedEnemy)) {
            multiplier += .5;
        }
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", Math.round(150 * multiplier))
            ]
        });
    }
};
DisembowelAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Disembowel)
], DisembowelAbilityHandler);
exports.DisembowelAbilityHandler = DisembowelAbilityHandler;
